import moment from "moment";
import { combineReducers } from "redux";

import { displayAddress } from "../helpers/Address";
import { displayNextDonationDate } from "../helpers/Donations";
import { replaceEmpty } from "../helpers/String";

// Constants for loading state.
const SETTINGS_LOAD_ERROR = 0;
const SETTINGS_LOAD_SUCCESS = 0;
const SETTINGS_LOAD_NEVER = 1;
const SETTINGS_LOADING = 2;
// eslint-disable-next-line no-unused-vars
const SETTINGS_NOOP = 13;

const details = (state = {}, action) => {
  switch (action.type) {
    case "SET_SETTINGS":
      return {
        ...state,
        ...action.settings,
      };
    default:
      return state;
  }
};

const creditCard = (state = {}, action) => {
  switch (action.type) {
    case "SET_SETTINGS_CREDIT_CARD":
      return {
        ...state,
        ...action.card,
      };
    default:
      return state;
  }
};

const directDebit = (state = {}, action) => {
  switch (action.type) {
    case "SET_SETTINGS_DIRECT_DEBIT":
      return {
        ...state,
        ...action.card,
      };
    default:
      return state;
  }
};

const settingsError = (state = null, action) => {
  switch (action.type) {
    case "SET_SETTINGS_ERROR":
      return action.message;
    default:
      return state;
  }
};

const settingsLoading = (state = SETTINGS_LOAD_NEVER, action) => {
  switch (action.type) {
    case "SET_SETTINGS_LOADING":
      return SETTINGS_LOADING;
    case "SET_SETTINGS":
      return SETTINGS_LOAD_SUCCESS;
    case "SET_SETTINGS_ERROR":
      return SETTINGS_LOAD_ERROR;
    default:
      return state;
  }
};

const settingsPersonalSaving = (state = null, action) => {
  switch (action.type) {
    case "SET_SETTINGS_PERSONAL_SAVING":
      return true;
    case "SET_SETTINGS_PERSONAL_ERROR":
    case "SET_SETTINGS_PERSONAL_SUCCESS":
    case "SET_SETTINGS_PERSONAL_DONE":
      return false;
    default:
      return state;
  }
};

const settingsPersonalSuccess = (state = null, action) => {
  switch (action.type) {
    case "SET_SETTINGS_PERSONAL_SUCCESS":
      return action.message;
    case "SET_SETTINGS_PERSONAL_ERROR":
    case "SET_SETTINGS_PERSONAL_SAVING":
    case "SET_SETTINGS_PERSONAL_DONE":
      return false;
    default:
      return state;
  }
};

const settingsPersonalError = (state = null, action) => {
  switch (action.type) {
    case "SET_SETTINGS_PERSONAL_ERROR":
      return action.message;
    case "SET_SETTINGS_PERSONAL_SAVING":
    case "SET_SETTINGS_PERSONAL_SUCCESS":
    case "SET_SETTINGS_PERSONAL_DONE":
      return false;
    default:
      return state;
  }
};

const settingsPersonalDone = (state = null, action) => {
  switch (action.type) {
    case "SET_SETTINGS_PERSONAL_DONE":
      return true;
    case "SET_SETTINGS_PERSONAL_SAVING":
    case "SET_SETTINGS_PERSONAL_SUCCESS":
    case "SET_SETTINGS_PERSONAL_ERROR":
      return false;
    default:
      return state;
  }
};

const settingsPasswordSaving = (state = null, action) => {
  switch (action.type) {
    case "SET_SETTINGS_PASSWORD_SAVING":
      return true;
    case "SET_SETTINGS_PASSWORD_ERROR":
    case "SET_SETTINGS_PASSWORD_SUCCESS":
    case "SET_SETTINGS_PASSWORD_DONE":
      return false;
    default:
      return state;
  }
};

const settingsPasswordSuccess = (state = null, action) => {
  switch (action.type) {
    case "SET_SETTINGS_PASSWORD_SUCCESS":
      return action.message;
    case "SET_SETTINGS_PASSWORD_ERROR":
    case "SET_SETTINGS_PASSWORD_SAVING":
    case "SET_SETTINGS_PASSWORD_DONE":
      return false;
    default:
      return state;
  }
};

const settingsPasswordError = (state = null, action) => {
  switch (action.type) {
    case "SET_SETTINGS_PASSWORD_ERROR":
      return action.message;
    case "SET_SETTINGS_PASSWORD_SAVING":
    case "SET_SETTINGS_PASSWORD_SUCCESS":
    case "SET_SETTINGS_PASSWORD_DONE":
      return false;
    default:
      return state;
  }
};

const settingsPasswordDone = (state = null, action) => {
  switch (action.type) {
    case "SET_SETTINGS_PASSWORD_DONE":
      return true;
    case "SET_SETTINGS_PASSWORD_SAVING":
    case "SET_SETTINGS_PASSWORD_SUCCESS":
    case "SET_SETTINGS_PASSWORD_ERROR":
      return false;
    default:
      return state;
  }
};

const settingsBillingSaving = (state = null, action) => {
  switch (action.type) {
    case "SET_SETTINGS_BILLING_SAVING":
      return true;
    case "SET_SETTINGS_BILLING_ERROR":
    case "SET_SETTINGS_BILLING_SUCCESS":
    case "SET_SETTINGS_BILLING_DONE":
      return false;
    default:
      return state;
  }
};

const settingsBillingSuccess = (state = null, action) => {
  switch (action.type) {
    case "SET_SETTINGS_BILLING_SUCCESS":
      return action.message;
    case "SET_SETTINGS_BILLING_ERROR":
    case "SET_SETTINGS_BILLING_SAVING":
    case "SET_SETTINGS_BILLING_DONE":
      return false;
    default:
      return state;
  }
};

const settingsBillingError = (state = null, action) => {
  switch (action.type) {
    case "SET_SETTINGS_BILLING_ERROR":
      return action.message;
    case "SET_SETTINGS_BILLING_SAVING":
    case "SET_SETTINGS_BILLING_SUCCESS":
    case "SET_SETTINGS_BILLING_DONE":
      return false;
    default:
      return state;
  }
};

const settingsBillingDone = (state = null, action) => {
  switch (action.type) {
    case "SET_SETTINGS_BILLING_DONE":
      return true;
    case "SET_SETTINGS_BILLING_SAVING":
    case "SET_SETTINGS_BILLING_SUCCESS":
    case "SET_SETTINGS_BILLING_ERROR":
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  details,
  settingsError,
  settingsLoading,
  settingsPersonalSaving,
  settingsPersonalSuccess,
  settingsPersonalError,
  settingsPersonalDone,
  settingsPasswordSaving,
  settingsPasswordSuccess,
  settingsPasswordError,
  settingsPasswordDone,
  settingsBillingSaving,
  settingsBillingSuccess,
  settingsBillingError,
  settingsBillingDone,
  creditCard,
  directDebit,
});

export const getSettings = (state) => state.details;
export const getSettingsLoading = (state) => state.settingsLoading;
export const getSettingsError = (state) => state.settingsError;
export const getSettingsPersonalSaving = (state) =>
  state.settingsPersonalSaving;
export const getSettingsPersonalSuccess = (state) =>
  state.settingsPersonalSuccess;
export const getSettingsPersonalError = (state) => state.settingsPersonalError;
export const getSettingsPersonalDone = (state) => state.settingsPersonalDone;
export const getSettingsPasswordSaving = (state) =>
  state.settingsPasswordSaving;
export const getSettingsPasswordSuccess = (state) =>
  state.settingsPasswordSuccess;
export const getSettingsPasswordError = (state) => state.settingsPasswordError;
export const getSettingsPasswordDone = (state) => state.settingsPasswordDone;
export const getSettingsCreditCard = (state) => state.creditCard;
export const getSettingsDirectDebit = (state) => state.directDebit;
export const getSettingsBillingSaving = (state) => state.settingsBillingSaving;
export const getSettingsBillingSuccess = (state) =>
  state.settingsBillingSuccess;
export const getSettingsBillingError = (state) => state.settingsBillingError;
export const getSettingsBillingDone = (state) => state.settingsBillingDone;
export const getCardExpired = (state) =>
  isExpired(getSettingsCreditCard(state));
export const getCardExpiring = (state, days = 30) =>
  isExpiring(getSettingsCreditCard(state), 30);

export const getSettingsIsStaff = (state) => {
  const details = getSettings(state);
  return details && Number(details.is_staff) === 1;
};

export const getSettingsPersonal = (state) => {
  const details = getSettings(state);

  return {
    honorific: replaceEmpty(details.honorific),
    honorific_other: replaceEmpty(details.honorific_other),
    first_name: replaceEmpty(details.first_name),
    last_name: replaceEmpty(details.last_name),
    phone: replaceEmpty(details.phone),
    mobile: replaceEmpty(details.mobile),
    email: replaceEmpty(details.email),
    organisation_name: replaceEmpty(details.organisation_name),
    address: displayAddress(details),
  };
};

export const getSettingsBilling = (state) => {
  const creditCard = getSettingsCreditCard(state);
  const directDebit = getSettingsDirectDebit(state);

  return {
    credit_card_name: creditCard.name,
    credit_card_number: creditCard.number_masked || creditCard.number,
    credit_card_expiry_date:
      typeof creditCard.expiry_date === "undefined"
        ? ""
        : creditCard.expiry_date.split("-").reverse().join("/"),
    credit_card_ccv: "***",

    direct_debit_name: directDebit.name,
    direct_debit_number: directDebit.number_masked || directDebit.number,
    direct_debit_date: displayNextDonationDate(
      { donation_schedule: "Monthly", debit_date: directDebit.payment_date },
      "YYYY-MM-DD"
    ),
    direct_debit_bsb: directDebit.bsb,

    terms_agree: false,
  };
};

const isExpiring = (creditCard, days = 0) => {
  // Define variables.
  let result = false;
  let date_expired = moment();
  const date_warning = moment().add(days, "d");

  // If we have a donation...
  if (
    typeof creditCard !== "undefined" &&
    typeof creditCard.type !== "undefined" &&
    typeof creditCard.expiry_date !== "undefined"
  ) {
    switch (creditCard.type) {
      case "MC":
      case "VC":
        // Convert the stored 'MMYY' date into something we can use.
        date_expired = moment(`${creditCard.expiry_date}-01`);

        // If our credit card expires before the warning date...
        if (date_warning > date_expired) {
          // Thsi card is expiring.
          result = true;
        }

        break;

      default:
    }
  }

  return result;
};

/**
 *
 * @param {object} creditCard the credit card object to determine if is expired or not
 *
 * @returns {bool} true if expiring
 */
const isExpired = (creditCard) => {
  if (
    typeof creditCard !== "undefined" &&
    typeof creditCard.type !== "undefined" &&
    typeof creditCard.expiry_date !== "undefined"
  ) {
    const expiry = moment(creditCard.expiry_date, "YYYY-MM");
    const today = moment();
    return today > expiry.add(1, "month");
  }
  return false;
};
